import React, { useState }  from 'react';

import { PostRequest } from 'components/common/index.js';

// stripeId names the subscription whose card this button updates. A customer can hold
// several subscriptions at once, each with its own payment method, so the server needs to
// be told which one was clicked rather than guessing at their first active subscription.
const UpdatePaymentMethod = ({ stripeId }) => {

  const [disabled, setDisabled] = useState('');
  const [cta, setCta] = useState(t('sign_up.update_my_card'));
  const stripe = Stripe(window.stripePublishableKey);

  const handleClick = (e) => {
    e.preventDefault();
    setDisabled( () => 'disabled' );
    setCta( () => t('sign_up.please_wait'))

    PostRequest({
      url: '/charges/create_checkout_session',
      data: { stripe_id: stripeId },
      callback: ( data ) => {
        setDisabled( () => '' );
        stripe.redirectToCheckout({
          sessionId: data.session_id
        })

      }
    })
  }

  return (
    <a className="btn subscription-card-action-primary" onClick={handleClick} disabled={disabled} href="#"> {cta} </a>
  )
}

export default UpdatePaymentMethod;
